import moment from "moment";

const minDate = moment("0001-01-01");

export const compareDates = (a?: moment.Moment, b?: moment.Moment): number => {
    return (a ?? minDate).diff(b ?? minDate);
};
